import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-member-dashboard',
  templateUrl: './member-dashboard.component.html',
  styleUrls: ['./member-dashboard.component.scss']
})
export class MemberDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
